module.exports = "data:image/gif;base64,R0lGODlhBwAKAPAAAP///93d3iH5BAUAAAAALAAAAAAHAAoAAAIQRAJph8mnXlvMPQqlhXGCAgA7"


//////////////////
// WEBPACK FOOTER
// ./static/img/xiaojiao.gif
// module id = S311
// module chunks = 1